import { withAuthenticationRequired } from 'react-oidc-context';

export function ProtectedRoute({ component, ...args }) {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
}
